const ITEMS = [
  "空 · sora — cer",
  "間 · ma — spațiul dintre lucruri",
  "一 · ichi — primul pas",
  "門 · mon — poarta spre altă lume",
  "道 · michi — drumul",
  "Același cer. Două culturi.",
  "limbă · cultură · stil de viață japonez",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-sumi/15 bg-washiaccent/60 py-5 overflow-hidden"
      aria-hidden
    >
      <div className="flex whitespace-nowrap animate-marquee-slow w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-xl sm:text-2xl text-sumi/70 px-8">{item}</span>
            <span className="text-hanko text-lg">✳</span>
          </span>
        ))}
      </div>
    </div>
  );
}
